import { render, staticRenderFns } from "./WhyOta.vue?vue&type=template&id=238dc8fe&scoped=true&"
import script from "./WhyOta.vue?vue&type=script&lang=js&"
export * from "./WhyOta.vue?vue&type=script&lang=js&"
import style0 from "./WhyOta.vue?vue&type=style&index=0&id=238dc8fe&scoped=true&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238dc8fe",
  null
  
)

export default component.exports